import React from 'react';
import { TextField } from '@material-ui/core';
import { useField } from 'react-final-form-hooks';
import _ from 'lodash';

export default function ({
  form, name, label, icon, margin = 'normal', type = 'text', children, hint, hidden, onChange, ...props
}) {
  const field = useField(name, form);
  const _onChange = (event) => {
    if(_.isFunction(onChange)) onChange(event);
    if (type === 'number') {
      if (event.target.value === '' || _.isNil(event.target.value)) return field.input.onChange('');

      return field.input.onChange(Number(event.target.value));
    }
    field.input.onChange(event);
  };


  if (hidden) {
    return null;
  }


  return (
    <TextField
      {...field.input}
      onChange={_onChange}
      value={field.input.value || ''}
      margin={margin}
      label={label}
      fullWidth
      type={type}
      size="small"
      variant="outlined"
      error={!!field.meta.touched && !!field.meta.error}
      helperText={(field.meta.touched) ? field.meta.error : null}
      {...props}
    />
  );
}
